<template>
  <div>
    <a-form :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
      <a-row>
        <a-col :span="6">
          <a-form-item label="资源标题">
            <a-input v-model.trim="searchForm.name" v-trim allowClear placeholder="请输入资源标题" :maxLength="20" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="类型">
            <a-select v-model="searchForm.fileType" placeholder="请选择类型" allowClear @change="(e) => (searchForm.fileType = e)">
              <a-select-option value="1">文档</a-select-option>
              <!-- <a-select-option value="2">PPT</a-select-option> -->
              <a-select-option value="4">视频</a-select-option>
              <a-select-option value="2">图片</a-select-option>
              <a-select-option value="3">音频</a-select-option>
              <a-select-option value="0">文件夹</a-select-option>
              <a-select-option value="5">压缩文件</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :wrapperCol="{ span: 24 }">
            <a-row style="display: flex; align-items: center">
              <a-col :span="12">
                <a-button type="primary" @click="getPageList(1)">查询</a-button>
                <a-button style="margin-left: 8px" @click="resetSearch">重置</a-button>
              </a-col>
              <a-col :span="12" style="display: flex; justify-content: end; align-items: center" v-if="!hasCurentQuote">
                <a-button @click="visibleFolder = true">新建文件夹</a-button>
                <a-button style="margin-left: 8px" type="primary" @click="addSource">选择资源</a-button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-card style="border-color: #dedede">
      <a-row v-if="breadcrumbList.length > 1" style="margin-bottom: 10px">
        <a-breadcrumb>
          <a-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="item.id">
            <span @click="handleBreadcrumb(index, item)" class="link"> {{ item.name }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>
      <a-row style="margin-bottom: 12px">
        <template v-if="selectedRowKeys.length">
          <a-tooltip>
            <template slot="title" v-if="hasSelect">当前选择资源包含不可移动文件，无法移动</template>
            <a-button type="primary" @click="movePackage" :disabled="hasSelect">移动</a-button>
          </a-tooltip>
          <a-tooltip>
            <template slot="title" v-if="hasSelect">当前选择资源包含不可删除文件，无法批量删除</template>
            <a-button type="danger" style="margin-left: 8px" @click="batchDel" :disabled="hasSelect">批量删除</a-button>
          </a-tooltip>
          <a-button style="margin-left: 8px" @click="batchChangeDownlaod(true)">允许下载</a-button>
          <a-button style="margin-left: 8px" @click="batchChangeDownlaod(false)">禁止下载</a-button>
        </template>
      </a-row>
      <a-row type="flex">
        <!-- <a-col :span="3" style="min-width: 210px; width: 210px">
          <a-tree :selectedKeys.sync="searchForm.categoryId" :tree-data="folderList" :replace-fields="replaceFields" @select="selectFolder">
            <template slot="custom" slot-scope="data">
              <span>{{ data.name }}</span>
            </template>
          </a-tree>
          <div v-if="!folderList.length" class="empty">暂无数据</div>
        </a-col> -->
        <a-col :span="24" style="flex: 1" class="table">
          <a-table
            :columns="gradeColumns"
            :rowSelection="rowSelection"
            :pagination="gradeTableRelevant.tablePagination"
            row-key="id"
            :loading="gradeTableRelevant.tableLoading"
            :data-source="gradeTableRelevant.tableDataSource"
          >
            <template slot="selection" slot-scope="text">
              <span>123456</span>
            </template>
            <div slot="name" class="table-name" slot-scope="text">
              <img :src="$getFileType(text.fileType).icon" style="width: 15px; height: 15px" />
              <a @click="nextFolder(text, true)" v-if="!text.fileType">{{ text.name }} </a>
              <span v-else :title="text.name">{{ text.name + suffix(text.fileName, 1) }}</span>
            </div>
            <div slot="downloadAuthority" slot-scope="text">
              <span v-if="text.fileType == 0">--</span>
              <!-- :disabled="text.source === 2" -->
              <a-switch v-else :checked="text.downloadAuthority" @change="changeDownload($event, text)"></a-switch>
            </div>
            <div slot="size" slot-scope="text">
              {{
                text.fileSize > 1024 * 1024
                  ? (text.fileSize / (1024 * 1024)).toFixed(2) + 'M'
                  : text.fileSize / 1024 < 1
                  ? text.fileSize
                    ? text.fileSize + 'B'
                    : '--'
                  : (text.fileSize / 1024).toFixed(2) + 'KB'
              }}
            </div>
            <div slot="fileType" slot-scope="text">
              {{ searchFileType[text.fileType] }}
              {{ text.fileType === 1 && text.fileName ? `（${suffix(text.fileName)}）` : '' }}
            </div>
            <div slot="action" class="action" slot-scope="text">
              <a v-if="![5, 0].includes(text.fileType)" :class="text.fileType === 5 ? 'disabled-btn' : ''" style="margin-right: 10px" href="javaScript:;" @click="view(text)"> 查看</a>
              <a style="margin-right: 10px" href="javaScript:;" @click="editSourceTitle(text)"> 编辑</a>
              <a href="#" class="c-red" :class="text.source === 2 ? 'disabled-btn' : ''" style="margin-right: 10px" @click="delRecord([text.id], null, true)">删除</a>
            </div>
          </a-table>
        </a-col>
      </a-row>
    </a-card>
    <a-modal title="新建文件夹" width="32%" :visible="visibleFolder" :confirm-loading="confirmLoading" @ok="handleFolderOk" @cancel="handleFolderCancel">
      <a-form :form="folderForm">
        <a-form-item label="名称" :labelCol="{ span: 4 }" :wrapperCol="{ span: 16 }">
          <a-input placeholder="请输入名称" :maxLength="20" v-decorator="['name', { rules: [{ validator: validator, required: true }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="编辑资源" width="32%" :visible="visibleSource" :confirm-loading="confirmLoading" @ok="handleSourceOk" @cancel="handleSourceCancel">
      <a-form :form="sourceForm">
        <a-form-item label="资源标题" :labelCol="{ span: 4 }" :wrapperCol="{ span: 16 }">
          <a-input placeholder="请输入资源标题" :maxLength="20" v-decorator="['name', { rules: [{ required: true, message: '请输入资源标题' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="移动资源" :centered="true" width="650px" v-model="moveVisible" @ok="batchModify" @cancel="handleMoveCancel" :confirm-loading="confirmLoading">
      <div class="move-wapper">
        移动到：
        <a-cascader
          :options="menuList"
          v-model="movecategoryId"
          placeholder="请选择"
          ref="moveCascader"
          allowClear
          :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          change-on-select
        />
        <div @click="$refs.moveCascader.$el.click()" class="move-btn">修改</div>
      </div>
    </a-modal>
    <a-modal v-model="preview.visible" :centered="true" title="预览" width="800px" :footer="null" destroyOnClose>
      <a-spin :spinning="preview.loading">
        <div v-if="preview.info.fileType === 3" style="padding: 30px">
          <my-audio :src="preview.src | filterUrl"></my-audio>
        </div>
        <div id="J_prismPlayer" style="height: 500px" v-if="preview.info.fileType === 4"></div>
        <div v-if="preview.info.fileType === 2" style="height: 500px">
          <img :src="preview.src | filterUrl" alt="" style="width: 100%; height: 500px; object-fit: cover" />
        </div>
      </a-spin>
    </a-modal>
    <SelectSource ref="SelectSourceRef" />
  </div>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import SelectSource from './selectSource'
import MyAudio from '@/components/audio/index.vue'
import Api from '@/requests/apis'

export default {
  components: { SelectSource, MyAudio },
  computed: {
    rowSelection() {
      return {
        onSelect: (record, selected) => {
          if (selected) {
            this.selectedRowKeys.push(record.id)
            this.selectRow.push(record)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => v != record.id)
            this.selectRow = this.selectRow.filter((v) => v.id != record.id)
          }
        },
        onSelectAll: (selected, selectedRows, changeRow) => {
          const ids = changeRow.map((v) => v.id)
          if (selected) {
            this.selectedRowKeys.push(...ids)
            this.selectRow.push(...changeRow)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => !(ids.indexOf(v) != -1))
            this.selectRow = this.selectRow.filter((v) => !(ids.indexOf(v.id) != -1))
          }
        },
        getCheckboxProps: (record) => ({
          props: {
            // disabled: record.source === 2,
          },
        }),
        selectedRowKeys: this.selectedRowKeys,
      }
    },
    hasSelect() {
      return this.selectRow.some((v) => v.source == 2)
    },
    hasCurentQuote() {
      const current = this.breadcrumbList.slice(-1)[0]
      if (current.fileResourceId) {
        return true
      } else {
        return false
      }
    },
    menuList() {
      const list = this.folderList.filter((v) => v.source != 2 && v.id >= 0)
      const stack = [...list]
      while (stack.length) {
        const item = stack.pop()
        if (this.selectedRowKeys.includes(item.id)) {
          item.disabled = true
        } else {
          item.disabled = false
        }
        if (item.children) {
          item.children.forEach((v) => stack.push(v))
        }
      }
      return list
    },
  },
  props: {
    pId: [Number],
  },
  data() {
    return {
      preview: {
        info: {},
      },
      moveVisible: false,
      movecategoryId: [0],
      replaceFields: {
        key: 'id',
        title: 'name',
        children: 'children',
      },
      breadcrumbList: [
        {
          name: '教学资源',
          id: undefined,
        },
      ],
      searchFileType: ['文件夹', '文档 ', '图片', '音频', '视频', '压缩文件'],
      gradeTableRelevant: tableRelevant.call(this),
      gradeColumns: [
        // {
        //   title: 'selection',
        //   dataIndex: 'selection',
        //   scopedSlots: { customRender: 'selection', title: 'titleName' },
        // },
        {
          title: '资源标题',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '源文件名称',
          dataIndex: 'sourceFileName',
        },
        {
          title: '大小',
          scopedSlots: { customRender: 'size' },
        },
        {
          title: '类型',
          scopedSlots: { customRender: 'fileType' },
        },
        {
          title: '下载权限',
          scopedSlots: { customRender: 'downloadAuthority' },
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
        },
      ],
      selectedRowKeys: [],
      selectRow: [],
      searchForm: {
        name: undefined,
        fileType: undefined,
      },
      folderForm: this.$form.createForm(this, { name: 'coordinated' }),
      sourceForm: this.$form.createForm(this, { name: 'coordinated' }),
      visibleFolder: false,
      visibleSource: false,
      confirmLoading: false,
      folderList: [],
    }
  },
  created() {
    if (this.pId) {
      this.getPageList(1)
      this.getTreeMenu()
    }
  },
  methods: {
    resetSearch() {
      this.searchForm.name = undefined
      this.searchForm.fileType = undefined
      this.getPageList(1)
    },
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.gradeTableRelevant.tablePagination.current,
        pageSize: this.gradeTableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        resourcePackageId: this.pId,
      }
      if (params.name || params.fileType !== undefined) {
        this.breadcrumbList = this.breadcrumbList.slice(0, 1)
        this.searchForm.categoryId = []
      }
      if (this.breadcrumbList.length > 1) {
        const item = this.breadcrumbList.slice(-1)[0]
        params.categoryId = item.id
        this.searchForm.categoryId = [item.id]
        // params.folderType = item.folderType
      } else {
        params.categoryId = (this.searchForm.categoryId || [])[0]
      }

      if (params.categoryId < 0) {
        params.categoryId = undefined
      }
      this.gradeTableRelevant.tableLoading = true
      this.$http.CourseResource.getPagelistPackage(params)
        .then((res) => {
          this.gradeTableRelevant.tableDataSource = res.data.items
          this.gradeTableRelevant.tablePagination.total = res.data.totalCount
          this.gradeTableRelevant.tablePagination.current = res.data.pageIndex
        })
        .finally(() => {
          this.gradeTableRelevant.tableLoading = false
        })
    },
    editSourceTitle(record = {}) {
      this._record = record
      this.visibleSource = true

      this.$nextTick(() => {
        this.sourceForm.setFieldsValue({
          name: record.name,
        })
      })
    },
    addSource() {
      const params = {
        resourcePackageId: this.pId,
        categoryId: this.breadcrumbList.slice(-1)[0].id,
      }
      this.$refs['SelectSourceRef'].showModal(params).then(({ keys }) => {
        const addParams = {
          resourcePackageId: this.pId,
          fileIds: keys,
          categoryId: this.breadcrumbList.slice(-1)[0].id,
        }
        this.$http.CourseResource.addPackage(addParams).then((res) => {
          this.$message.success('添加成功')
          this.getPageList(1)
          this.getTreeMenu()
        })
      })
    },
    changeDownload(e, reocrd) {
      const fm = new FormData()
      fm.append('ids', reocrd.id)
      fm.append('isDownload', e)
      this.$http.CourseResource.changeDownload(fm).then((res) => {
        this.$message.success('操作成功')
        this.getPageList(1)
      })
    },
    delRecord(ids, cb, bol) {
      if (bol) {
        this.$confirm({
          title: `删除资源`,
          content: '资源将从该教学资源包中删除，请谨慎操作，是否确认删除？',
          onOk: () => {
            this.$http.CourseResource.deletePackage(ids).then((res) => {
              this.$message.success('操作成功')
              this.getPageList(1)
              this.getTreeMenu()
              cb && cb()
            })
          },
        })
      } else {
        this.$http.CourseResource.deletePackage(ids).then((res) => {
          this.$message.success('操作成功')
          this.getPageList(1)
          this.getTreeMenu()
          cb && cb()
        })
      }
    },
    batchModify() {
      const params = {
        fileIds: this.selectedRowKeys,
        categoryId: this.movecategoryId.slice(-1)[0] || undefined,
        resourcePackageId: this.pId,
      }
      this.$http.CourseResource.batchModify(params).then((res) => {
        this.$message.success('操作成功')
        this.getPageList(1)
        this.getTreeMenu()
        this.selectedRowKeys = []
        this.moveVisible = false
        this.handleMoveCancel()
      })
    },
    movePackage() {
      if (this.selectedRowKeys.length == 0) {
        return this.$message.warning('请至少选择一个文件')
      }
      this.moveVisible = true
    },
    getTreeMenu() {
      function initTree(data = []) {
        return data.map((v) => {
          v.scopedSlots = { title: 'custom' }
          if (v.children) {
            v.children = initTree(v.children)
          }
          return v
        })
      }
      this.$http.CourseResource.getTreeMenu({ id: this.pId }).then((res) => {
        this.folderList = [
          {
            name: '教学资源',
            id: 0,
            children: res.data.filter((v) => v.id !== -1),
          },
        ]
        this.folderList = initTree(this.folderList)
      })
    },
    getByFold(id) {
      const stack = [...this.folderList]
      while (stack.length) {
        const item = stack.pop()
        if (item.id == id) {
          return item
        }
        if (item.children) {
          item.children.forEach((v) => stack.push(v))
        }
      }
    },
    batchDel() {
      if (this.selectedRowKeys.length == 0) {
        return this.$message.warning('请至少选择一个文件')
      }
      this.$confirm({
        title: `删除${this.selectedRowKeys.length}个资源`,
        content: '资源将从该教学资源包中删除，请谨慎操作，是否确认删除？',
        onOk: () => {
          this.delRecord(this.selectedRowKeys, () => {
            this.selectedRowKeys = []
          })
        },
      })
    },
    batchChangeDownlaod(bol) {
      if (this.selectedRowKeys.length == 0) {
        return this.$message.warning('请至少选择一个文件')
      }
      this.$confirm({
        title: `${bol ? '允许' : '禁用'}下载${this.selectedRowKeys.length}个资源`,
        content: `${bol ? '' : '禁用的资源将不可下载？'}`,
        onOk: () => {
          const fm = new FormData()
          this.selectedRowKeys?.forEach((v) => {
            fm.append('ids', v)
          })
          fm.append('isDownload', bol)
          this.$http.CourseResource.changeDownload(fm).then((res) => {
            this.$message.success('操作成功')
            this.getPageList(1)
            this.selectedRowKeys = []
          })
        },
      })
    },
    handleSourceOk() {
      this.sourceForm.validateFields((err, values) => {
        if (!err) {
          const fm = new FormData()
          fm.append('id', this._record.id)
          fm.append('name', values.name)
          this.$http.CourseResource.editpkName(fm).then((res) => {
            this.$message.success('修改成功')
            this.handleSourceCancel()
            this._record = {}
            this.getPageList(1)
            this.getTreeMenu()
          })
        }
      })
    },
    handleSourceCancel() {
      this.visibleSource = false
      this._record = {}
      this.sourceForm.resetFields()
    },
    handleFolderOk() {
      this.folderForm.validateFields((err, values) => {
        if (!err) {
          const params = { resourcePackageId: this.pId, categoryId: this.breadcrumbList.slice(-1)[0].id, path: values.name, fileIds: [] }
          this.$http.CourseResource.addPackage(params).then(() => {
            this.$message.success('添加成功')
            this.handleFolderCancel()
            this._record = {}
            this.getPageList(1)
            this.getTreeMenu()
          })
        }
      })
    },
    handleFolderCancel() {
      this.visibleFolder = false
      this._record = {}
      this.folderForm.resetFields()
    },
    handleMoveCancel() {
      this.movecategoryId = [0]
      this.moveVisible = false
    },
    validator(_, value) {
      return new Promise((resolve, reject) => {
        if (!value && value !== 0) {
          reject(new Error('请输入文件夹名称'))
        } else {
          resolve()
        }
      })
    },
    selectFolder(e = []) {
      if (!e[0] || e[0] < 0) {
        this.breadcrumbList = this.breadcrumbList.slice(0, 1)
        this.getPageList(1)
      } else {
        const item = this.getByFold(e[0])
        if (item) {
          this.breadcrumbList = this.breadcrumbList.slice(0, 1)
          if (item.parentId) {
            const item2 = this.folderList.find((v) => v.fileResourceId == item.parentId)
            if (item2) {
              this.nextFolder(item2)
            }
          }
          this.nextFolder(item, true)
        } else {
          this.getPageList(1)
        }
      }
    },
    nextFolder(record, flag) {
      this.breadcrumbList.push({
        id: record.id,
        name: record.name,
        categoryId: record.categoryId,
        folderType: record.folderType,
        source: record.source,
        fileResourceId: record.fileResourceId,
      })
      this.searchForm.name = undefined
      this.searchForm.fileType = undefined
      this.searchForm = { ...this.searchForm }
      flag && this.getPageList(1)
    },
    handleBreadcrumb(index, item) {
      this.breadcrumbList = this.breadcrumbList.slice(0, index + 1)
      if (this.breadcrumbList.length === 1) {
        this.searchForm.categoryId = []
      }
      this.getPageList(1)
    },
    view(val) {
      this.$message.destroy()
      if (val.fileType === 5) {
        this.$message.error('文件不支持预览')
        return
      }
      if (!val.fileType) {
        this.nextFolder(val, true)
        return
      }
      this.preview = {
        visible: true,
        loading: false,
        info: val,
        src: process.env.VUE_APP_API_BASE_URL + Api.Content.downloadFileStream + '?id=' + val.fileResourceId,
      }
      if (val.fileType === 4) {
        const params = { id: val.fileResourceId }
        this.$http.FileResource.getVideoPlayAuth(params)
          .then((res) => {
            const { data, status, message } = res
              this.$nextTick(() => {
                new Aliplayer(
                  {
                    id: 'J_prismPlayer',
                    width: '100%',
                    height: '500px',
                    autoplay: true,
                    vid: data.videoId, //播放方式二必选参数。可以通过点播控制台（媒资库>音/视频路径）查询。示例：1e067a2831b641db90d570b6480f****。
                    playauth: data.playAuth, //播放方式二必选参数。参数值可通过调用GetVideoPlayAuth接口获取。
                  },
                  (player) => {
                    console.log('The player is created.')
                  }
                )
              })
           
          })
          .catch((e) => {
            this.preview.visible = false
          })
      }
      if (val.fileType === 2) {
        this.preview.loading = true
        const xhr = new XMLHttpRequest()
        xhr.open('GET', this.preview.src, true)
        xhr.responseType = 'blob'
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.getters['account/token']())
        xhr.send(null)
        xhr.onload = () => {
          this.preview.src = window.URL.createObjectURL(xhr.response)
          this.preview.loading = false
        }
      }
      if (val.fileType === 1) {
        this.preview.visible = false
        const Params = {
          materialId: val.fileResourceId,
        }
        this.$http.resourcesList.GeneratePresignedUri(Params).then((res) => {
          const { status, data, message } = res
            window.open(data)
         
        })
      }
    },
    suffix(str, point) {
      str = str || ''
      if (point) {
        return str.substring(str.lastIndexOf('.')).toLowerCase()
      }
      return str.substring(str.lastIndexOf('.') + 1).toLowerCase()
    },
  },
}
</script>
<style lang="less" scoped>
.table-name {
  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
}
.link {
  cursor: pointer;
}
.move-wapper {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  width: 500px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding-left: 10px;

  .move-btn {
    width: 90px;
    height: 100%;
    text-align: center;
    border-left: 1px solid #d9d9d9;
    font-weight: bold;
    line-height: 35px;
    cursor: pointer;
  }

  .ant-cascader-picker {
    flex-grow: 1;
  }

  .ant-cascader-picker:focus /deep/ .ant-cascader-input {
    border: none !important;
    box-shadow: none !important;
  }

  /deep/ .ant-cascader-picker-label {
    padding-left: 5px;
  }

  /deep/ i {
    display: none;
  }

  /deep/ .ant-cascader-input {
    border: none;
    outline: none;
  }

  /deep/ .ant-cascader-input:focus {
    border: none !important;
    box-shadow: none !important;
  }
}
.empty {
  color: #666;
  text-align: center;
}
.table .check-half {
  ::v-deep .ant-checkbox-inner {
    background: #fff;
    position: relative;
  }
  ::v-deep .ant-checkbox-inner::after {
    content: '';
    width: 8px;
    height: 8px;
    display: inline-block;
    background: var(--color);
    top: 50%;
    left: 50%;
    border: 0;
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}
</style>
